export const COLORS = {
  bg: "#FAFAF7",
  cardBg: "#FFFFFF",
  border: "#EEEDE7",
  skeleton: "#EEEDE7",
  skeletonLight: "#F2F1ED",
  textPrimary: "#0A0B0F",
  textSecondary: "#5A5E68",
  textTertiary: "#8A8E97",
  dark: "#0A0B0F",
  light: "#FAFAF7",
};

export const FONT_FAMILY = "Inter, system-ui, -apple-system, sans-serif";

export const INTERNAL_ORG_NAME = "Wieldy";
